import * as React from 'react'

import {Button, Form, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from '../../assets/css/app.scss';
import {observable, runInAction} from "mobx";
import {redirect} from "../../../src/common/Router/routerCommon";
import {fetchWithCsrf} from "../../../src/utils/csrf";
import {CompanyConstants} from "../../../src/constants/Views/Companies/CompanyConstants";
import {FastlaneService} from "../../service/FastlaneService";

// const FormItem = Form.Item;

@observer
class UseFastlane extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;
  fastLaneService = new FastlaneService(this.formUtils, 1);
  loungeService = new FastlaneService(this.formUtils, 2);

  isFastlane = true;

  @observable
  remaining = 0;

  @observable
  isModalVisible = false;

  @observable
  accountInfo:any = {};

  componentWillMount() {

    loginUserStore.getLoginUser().then(() => {
      fetchWithCsrf(KIX_GBC_API_PATH + "/check_account_condition", {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({}),
      }).then(async (res: any) => {
        const json = await res.json();
        runInAction(() => {
          if (json.result.code == 1) {
            this.accountInfo = json.value;
          } else {
            message.error(json.result.message);
          }
        });
      }).catch((_e: any) => {
        message.error("通信に失敗しました。画面を更新して下さい。");
      });
    });
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <><KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>マイページ・会員証</h2>

        <div className={commonStyles.f}>
          <div className={commonStyles.fCenter+" "+commonStyles.fAItemTop} style={{width: "40%", margin: "2em"}}>
            <div className={commonStyles.fCenter} style={{width: "100%"}}>
              <img src={require("../../assets/viewImg/memberCard.gif")} style={{width: "95%", marginBottom: "1em"}}/>
            </div>
          </div>

          <div className={commonStyles.f1}>
            <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter}>
              <div style={{fontSize: "1.1em", width: "100%"}}>
                <div className={appStyles.textWhite + " " + commonStyles.f}
                     style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                  <span>ステータス</span>
                  <span className={commonStyles.fItemRight}>{loginUserStore.loginUserInfo.company && CompanyConstants.status[loginUserStore.loginUserInfo.company!.status]}</span>
                </div>
                <div className={appStyles.textWhite + " " + commonStyles.f}
                     style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                  <span>企業コード</span>
                  <span className={commonStyles.fItemRight}>{(("000") + loginUserStore.loginUserInfo.companyId).substr(-4)}</span>
                </div>
                <div className={appStyles.textWhite + " " + commonStyles.f}
                     style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                  <span>企業名</span>
                  <span className={commonStyles.fItemRight}>{loginUserStore.loginUserInfo.company && loginUserStore.loginUserInfo.company!.name}</span>
                </div>
                <div className={appStyles.textWhite + " " + commonStyles.f}
                     style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                  <span>有効期限</span>
                  <span className={commonStyles.fItemRight} style={{fontSize: "1.25em"}}>{this.accountInfo.expiration_dt}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={commonStyles.f1}>
          <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter}>
            <div style={{fontSize: "1.1em", width: "100%"}}>
              <p className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em", borderRadius: "0.5em", textAlign: "center"}}>Fast Lane</p>

              <div className={appStyles.textWhite + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                <span>ご利用回数</span>
                <span className={commonStyles.fItemRight}>{this.accountInfo.fastlane_used_count} 回／年</span>
              </div>
              <div className={appStyles.textWhite + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                <span>残りご利用回数</span>
                <span className={commonStyles.fItemRight}>{this.accountInfo.fastlane_remaining} 回／年</span>
              </div>

              <p className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em", borderRadius: "0.5em", textAlign: "center"}}>ラウンジ</p>

              <div className={appStyles.textWhite + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                <span>ご利用回数</span>
                <span className={commonStyles.fItemRight}>{this.accountInfo.lounge_used_count} 回／年</span>
              </div>
              <div className={appStyles.textWhite + " " + commonStyles.f}
                   style={{marginBottom: "1em", borderBottom: "0.5px solid #bfc4d8", padding: "0.5em"}}>
                <span>残りご利用回数</span>
                <span className={commonStyles.fItemRight}>{this.accountInfo.lounge_remaining} 回／年</span>
              </div>
            </div>
          </div>
          {/*<div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter}>*/}
            {/*<div className={appStyles.textWhite} style={{width: "100%"}}>*/}
              {/*※会員様のみご利用いただけます。<br/>*/}
              {/*※関西国際空港以外ではご利用いただけません。<br/>*/}
              {/*※この通行許可証は「ラウンジ」で利用できません。<br/>*/}
              {/*※許可証の有効期間は搭乗日から起算して３日間です。<br/>*/}
              {/*※印刷した許可証はスタッフが回収させていただきます。<br/>*/}
            {/*</div>*/}
          {/*</div>*/}
        </div>

        <div style={{margin: "2em 0 0 0"}} className={commonStyles.fCenter}>

          <div style={{fontSize: "1.1em"}}>

          </div>
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter}>
          <Button onClick={() => (window as any).print()} size={"large"} className={`${appStyles.buttonGray}`}
                  style={{color: "white", padding: "0 5em 0 5em", height: "3.5em"}}>
            印刷する
          </Button>
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter}>
          {/*<Button onClick={this.fastLaneService.redirectInquiryOrConfirm} size={"large"} className={`${appStyles.buttonDarkBlue}`}*/}
          {/*        style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>*/}
          {/*  Fast Laneを利用する*/}
          {/*</Button>*/}
          <Button onClick={this.loungeService.redirectInquiryOrConfirm} size={"large"} className={`${appStyles.buttonDarkBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            ラウンジを利用する
          </Button>
          {/*<Button onClick={() => redirect("/my_page")} size={"large"} className={`${appStyles.buttonDarkBlue}`}*/}
                  {/*style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>*/}
            {/*マイページ*/}
          {/*</Button>*/}
        </div>

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter}>
          <Button onClick={() => redirect("/")} size={"large"} className={`${appStyles.buttonDeepBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            GBC会員専用TOPへ
          </Button>
        </div>

        {this.fastLaneService.displayModal()}
        {this.loungeService.displayModal()}
      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(UseFastlane)

